"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tidalAxios = void 0;
const axios_1 = __importDefault(require("axios"));
const http = __importStar(require("http"));
const https = __importStar(require("https"));
const fast_safe_stringify_1 = __importDefault(require("fast-safe-stringify"));
const axios_retry_1 = __importDefault(require("axios-retry"));
const axios_retry_2 = require("axios-retry");
const httpAgent = new http.Agent({ keepAlive: true });
const httpsAgent = new https.Agent({ keepAlive: true });
/** Checks the conditions and logs the error if they pass */
function maybeLogError(axiosError, serviceName, errorToLog, tidalAxiosConfig) {
    const shouldLogError = tidalAxiosConfig && (typeof tidalAxiosConfig.shouldLogError === 'function'
        && tidalAxiosConfig.shouldLogError(axiosError) || typeof tidalAxiosConfig.shouldLogError === 'boolean'
        && tidalAxiosConfig.shouldLogError);
    if (shouldLogError) {
        console.error(`${serviceName} logging error. AxiosError: ${(0, fast_safe_stringify_1.default)(errorToLog, undefined, 2)}`);
    }
}
/** Adds interceptors and loggers to axios */
function tidalAxios(serviceName, tidalAxiosConfig) {
    const instance = axios_1.default.create({
        timeout: tidalAxiosConfig && typeof tidalAxiosConfig.timeout === 'number'
            ? tidalAxiosConfig.timeout : 5000,
        httpAgent,
        httpsAgent,
    });
    // only retry if shouldRetry is provided
    (0, axios_retry_1.default)(instance, {
        retries: 3,
        retryCondition: (error) => {
            const useRetryFunctionality = tidalAxiosConfig && (typeof tidalAxiosConfig.shouldRetry === 'boolean'
                && tidalAxiosConfig.shouldRetry || typeof tidalAxiosConfig.shouldRetry === 'function'
                && tidalAxiosConfig.shouldRetry(error));
            return Boolean((0, axios_retry_2.isNetworkOrIdempotentRequestError)(error) && useRetryFunctionality);
        },
    });
    // request interceptor
    instance.interceptors.request.use(function (config) {
        // log the config before the request
        if (tidalAxiosConfig && tidalAxiosConfig.enableRequestLogging) {
            if (config) {
                const configToLog = {
                    params: config.params,
                    method: config.method,
                    baseURL: config.baseURL,
                    data: config.data,
                    headers: config.headers,
                    url: config.url,
                };
                // replace the passwords if any
                const logData = (0, fast_safe_stringify_1.default)(configToLog, undefined, 2).replace(/password=(.+?&)/, 'password=******&');
                console.info(`${serviceName} logging before request. AxiosConfig: ${logData}`);
            }
        }
        return config;
    }, function (error) {
        maybeLogError(error, serviceName, error, tidalAxiosConfig);
        return Promise.reject(error);
    });
    // response interceptor
    instance.interceptors.response.use(function (response) {
        return response;
    }, function (error) {
        const config = error.config;
        if (!config) {
            return Promise.reject(error);
        }
        const errorToLog = {
            method: config.method,
            baseURL: config.baseURL,
            data: error.response ? error.response.data : 'No axiosError.response. Possible timeout',
            status: error.response ? error.response.status : error.status,
            statusText: error.response ? error.response.statusText : 'No axiosError.response. Possible timeout',
            requestHeaders: config.headers,
            responseHeaders: error.response ? error.response.headers : 'No axiosError.response. Possible timeout',
            url: config.url,
            stack: error.stack,
            message: error.message,
        };
        maybeLogError(error, serviceName, errorToLog, tidalAxiosConfig);
        return Promise.reject(error);
    });
    return instance;
}
exports.tidalAxios = tidalAxios;
